/*global FakeCation, document, fbq */
(function (FC) {
  "use strict";
  var pageId = '887658944645950';

  /* eslint-disable */
  !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
  n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
  n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
  t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,
  document,'script','//connect.facebook.net/en_US/fbevents.js');
  /* eslint-enable */

  fbq('init', pageId);
  // fbq('track', 'PageView');

  FC.fbq = function(cname, type) {
    type = type || 'ViewContent';
    fbq('track', type, {
      content_name: cname || 'Unknown'
    });
  };

  // initial page view tracking
  // FC.fbq('Welcome Page');

}(FakeCation));
